<template>
  <b-form-group
    label="Anahtar Kelimeler"
    label-for="keywords"
  >
    <validation-provider
      #default="{ errors }"
      name="Anahtar Kelimeler"
      rules="required"
    >
      <b-form-tags
        id="keywords"
        v-model="dataItem.keywords"
        placeholder="Anahtar Kelimeler"
        add-button-text="Ekle"
        add-button-variant="success"
        duplicate-tag-text="Bu anahtar kelime kullanılıyor"
        tag-pills
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BFormTags,
} from 'bootstrap-vue'
import { required } from '@validations'

export default {
  name: 'KeywordTags',
  components: {
    BFormGroup,
    BFormTags,
    ValidationProvider,
  },
  data() {
    return {
      required,
      locale: 'tr',
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['zennoStocks/dataItem']
    },
  },
  created() {
    localize(this.locale)
  },
}
</script>
